import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import RoutesApp from './routes';
import "./App.css"

function App() {
  return (
    <HelmetProvider>
      <div className='app-container'>
        <RoutesApp/>
      </div>
    </HelmetProvider>
  );
}

export default App;
